import { useEffect, useMemo, useState } from "react";
import { useTable } from "react-table";
import primaryComponents from "../../primaryComponents";
import { useNavigate, useSearchParams } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";
import { defaultDateDisplay } from "../../../helpers";

const getTableProperties = (
  isAvailable,
  setSelectedUpdateItem,
  setSelectedDeleteItem,
  navigate,
) => {
  const header1 = [
    {
      Header: "Tracking Number",
      accessor: "item_number",
    },
    {
      Header: "Item Name",
      accessor: "item_name",
    },
    {
      Header: "Order Number",
      accessor: "order_id",
      Cell: ({ cell: { value } }) => (
        <>
          {value ? (
            <span
              className="purple--text"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate(
                  `${pathConstants.INVENTORY_SALES_TRANSACTIONS}?orderId=${value}`,
                );
              }}
            >
              {value}
            </span>
          ) : (
            "N/A"
          )}
        </>
      ),
    },
    {
      Header: "Store",
      accessor: "store",
      Cell: ({ cell: { value } }) => <span>{value?.name || "N/A"}</span>,
    },
    ...(!isAvailable
      ? [
          {
            Header: "Customer",
            accessor: "order_customer",
            Cell: ({ cell: { value } }) => (
              <span>{value?.first_name || "N/A"}</span>
            ),
          },
        ]
      : []),
    {
      Header: "Restock Date",
      accessor: "created_at",
      Cell: ({ cell: { value } }) => <span>{defaultDateDisplay(value)}</span>,
    },
    ...(!isAvailable
      ? [
          {
            Header: "Date Sold",
            accessor: "sold_at",
            Cell: ({ cell: { value } }) => (
              <span>{value ? defaultDateDisplay(value) : "N/A"}</span>
            ),
          },
        ]
      : []),
    {
      Header: "Added By",
      accessor: "created_by",
      Cell: ({ cell: { value } }) => <span>{value?.first_name || "N/A"}</span>,
    },
    ...(isAvailable
      ? [
          {
            Header: "Actions",
            accessor: "",
            Cell: ({ cell: { row } }) => (
              <div className="d-flex" style={{ gap: "5px" }}>
                <primaryComponents.Button
                  classNames={"btn btn--outline smallBtn"}
                  isDisabled={!isAvailable}
                  onClick={() => {
                    setSelectedUpdateItem(row?.original);
                  }}
                >
                  Update
                </primaryComponents.Button>

                <primaryComponents.Button
                  classNames="btn btn--danger smallBtn"
                  isDisabled={!isAvailable}
                  onClick={() => {
                    setSelectedDeleteItem(row?.original);
                  }}
                >
                  Delete
                </primaryComponents.Button>
              </div>
            ),
          },
        ]
      : []),
  ];

  return [...header1];
};
const useTrackItemTable = ({ trackedItems = [] }) => {
  const navigate = useNavigate();
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [selectedUpdateItem, setSelectedUpdateItem] = useState(null);
  const [search] = useSearchParams();
  const [header, setHeader] = useState(
    getTableProperties(search.get("is_sold") === "false"),
    setSelectedUpdateItem,
    setSelectedDeleteItem,
    navigate,
  );

  useEffect(() => {
    setHeader(
      getTableProperties(
        search.get("is_sold") === "false",
        setSelectedUpdateItem,
        setSelectedDeleteItem,
        navigate,
      ),
    );
  }, [search]);

  const columns = useMemo(() => {
    return header;
  }, [header]);

  const instance = useTable({ columns, data: trackedItems });

  return {
    instance,
    selectedDeleteItem,
    selectedUpdateItem,
    search,
    setSelectedDeleteItem,
    setSelectedUpdateItem,
  };
};
export default useTrackItemTable;
